// EN: event name / ED: event description
const BUTTON_CLICKED_SUFFIX = 'button clicked';
const PAYWALL_SEEN_SUFFIX = 'paywall seen';
const TYPE = {
  FEATURE: 'feature',
  MARKETING: 'marketing',
  ADDITIONAL_QUANTITIES: 'additional_quantities',
  ONBOARDING: 'onboarding',
  SIGNUP: 'signup',
  TECHNICAL: 'technical',
};

const LOCATION = {
  UNKNOWN: 'unknown',
};

const TRIGGER = {
  UNKNOWN: 'unknown',
};

export default {
  BASE_VALUES: {
    bank_add_tentative: 40,
    bank_added: 110,
    free_trial: 230,
  },
  EN_PROACTIVE_SUBSCRIPTION_BUTTON_CLICKED: {
    name: `Proactive subscription ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'proactive_subscription_button'},
  },
  EN_FUNDING_BUTTON_CLICKED: {
    name: `Funding ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'funding_button', type: TYPE.MARKETING},
  },
  EN_SCENARIO_BUTTON_CLICKED: {
    name: `Scenario ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'scenario_button', type: TYPE.FEATURE},
  },
  EN_ONBOARDING_BUTTON_CLICKED: {
    name: `Onboarding ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'onboarding_button'},
  },
  EN_AVSE_UNLOCK_BUTTON_CLICKED: {
    name: `Unlock AvsE ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'avse_button', type: TYPE.FEATURE},
  },
  EN_EXCEL_UNLOCK_BUTTON_CLICKED: {
    name: `Unlock Excel export ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'excel_button', type: TYPE.FEATURE},
  },
  EN_ADD_USER_BUTTON_CLICKED: {
    name: `Add a user ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'add_user_button', type: TYPE.ADDITIONAL_QUANTITIES},
  },
  EN_ADD_BANK_BUTTON_CLICKED: {
    name: `Add a bank ${BUTTON_CLICKED_SUFFIX}`,
    properties: {
      id: 'add_bank_button',
      type: TYPE.ADDITIONAL_QUANTITIES,
      location: LOCATION.UNKNOWN,
    },
  },
  EN_VIEW_RULES_BUTTON_CLICKED: {
    name: `View my rules ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'view_rules_button', type: TYPE.FEATURE},
  },
  EN_VIEW_PERMISSION_GROUPS_BUTTON_CLICKED: {
    name: `View permission groups ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'view_permission_groups_button', type: TYPE.FEATURE},
  },
  EN_FILTER_TRANSACTIONS_BUTTON_CLICKED: {
    name: `Filter transactions ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'filter_transactions_button', location: LOCATION.UNKNOWN},
  },
  EN_UPGRADE_BUTTON_CLICKED: {
    name: `Upgrade ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'upgrade_button', trigger: TRIGGER.UNKNOWN},
  },
  EN_USER_REDIRECTED_TO_AIS_PROVIDER: {
    name: `User redirected to AIS provider ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'ais_redirection'},
  },
  EN_BANK_SEARCHED: {
    name: 'Bank searched',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_BANK_NOT_FOUND: {
    name: 'Bank not found',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_COMPANY_SEARCHED: {
    name: 'Company searched',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_SIGNUP_CLICKED: {
    name: `Sign up ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.SIGNUP},
  },
  EN_SIGNUP_PAGE_VIEWED: {
    name: 'Sign up page viewed',
    properties: {type: TYPE.SIGNUP},
  },
  EN_FREE_TRIAL_PAYWALL_SEEN: {
    name: `Free trial ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'free_trial_paywall'},
  },
  EN_CATEGORY_LEVEL_PAYWALL_SEEN: {
    name: `Category level ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'category_level_paywall'},
  },
  EN_AVSE_PAYWALL_SEEN: {
    name: `Avse ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'avse_paywall'},
  },
  EN_SCENARIO_NUMBER_PAYWALL_SEEN: {
    name: `Scenario number ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'scenario_number_paywall'},
  },
  EN_EXCEL_PAYWALL_SEEN: {
    name: `Excel ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'excel_paywall'},
  },
  EN_PERMISSION_GROUPS_PAYWALL_SEEN: {
    name: `Permission groups ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'permission_groups_paywall'},
  },
  EN_ADDITIONAL_BANK_PAYWALL_SEEN: {
    name: `Aadditional bank ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_bank_paywall'},
  },
  EN_ANALYTICS_PAYWALLS_SEEN: {
    name: `Analytics ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'analytics_paywall'},
  },
  EN_ADDITIONAL_USER_PAYWALL_SEEN: {
    name: `Additional user ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_user_paywall'},
  },
  EN_ADDITIONAL_INTEGRATION_PAYWALLS_SEEN: {
    name: `Additional integration ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_integration_paywall'},
  },
  EN_ADD_PARTNER_INTEGRATION_BUTTON_CLICKED: {
    name: `Add a partner integration ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'add_partner_integration_button', type: TYPE.FEATURE},
  },
  EN_UPDATE_PARTNER_INTEGRATION_BUTTON_CLICKED: {
    name: `Update a partner integration ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'update_partner_integration_button', type: TYPE.FEATURE},
  },
  EN_PARTNER_CARD_BUTTON_CLICKED: {
    name: `Partner card ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'partner_card_button', type: TYPE.FEATURE},
  },
  EN_USER_SESSION_STARTED: {
    name: 'User started a new session of navigation',
    properties: {type: TYPE.TECHNICAL},
  },
  EN_TREASURY_INVESTMENT_BUTTON_CLICKED: {
    name: `Treasury investment ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_SUBSCRIPTION_BUTTON_CLICKED: {
    name: `Treasury subscription ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_WITHDRAWAL_BUTTON_CLICKED: {
    name: `Treasury withdrawal ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_TRANSFER_ORDERED: {
    name: `Treasury transfer ordered`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_BTN_CLICKED: {
    name: `AI forecasts button clicked`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_CREATED: {
    name: `AI forecasts created`,
    properties: {type: TYPE.FEATURE},
  },
  EN_LOCALSTORAGE_CLEAR: {
    name: `LOCALSTORAGE removed largest item`,
    properties: {type: TYPE.TECHNICAL},
  },
  EN_CUSTOM_REPORT_CREATED: {
    name: `Custom report button clicked`,
    properties: {type: TYPE.FEATURE},
  },
  EN_CUSTOM_INDICATOR_CREATE_FAIL: {
    name: `Creation of a custom indicator failed`,
    properties: {type: TYPE.FEATURE},
  },
  EN_INTERNAL_TRANSFER_ATTEMPT: {
    name: `Attempt to transfer funds between user accounts`,
    properties: {type: TYPE.FEATURE},
  },
  EN_MAINTENANCE_VIEW_SHOWN: {
    name: `User redirected to maintenance view`,
    properties: {type: TYPE.TECHNICAL},
  },
  EN_PRESENTATION_VIEWED: {
    name: `Presentation viewed`,
    properties: {id: 'presentation', type: TYPE.MARKETING},
  },
  EN_PRESENTATION_WATCH_ENDED: {
    name: `Presentation watch ended`,
    properties: {id: 'presentation', type: TYPE.MARKETING},
  },
};
